<template>
  <div class="bm-view">
    <baidu-map
      class="bm-view"
      :center="center"
      :zoom="zoom"
      :min-zoom="16"
      :max-zoom="19"
      :scroll-wheel-zoom="true"
      :mapClick="false"
      @ready="setDistanceToolInstance"
    >
      <bm-traffic> </bm-traffic>
      <div v-for="item in messageList" :key="item.content">
        <bm-label
          :content="item.content"
          :position="item.position"
          :labelStyle="{
            color: 'white',
            fontSize: '12px',
            border: 'none',
            borderRadius: '0.25rem',
            background: 'rgba(0,0,0,75%)',
            padding: '4px',
          }"
          :massClear="false"
          :offset="{ width: 24, height: -10 }"
        />
      </div>
      <bm-boundary
        name="惠州市"
        :strokeWeight="2"
        strokeColor="blue"
        fillColor=""
        @remove="handleOverflow"
        @click="handleOverflow"
      ></bm-boundary>
      <div id="center-selector"></div>
      <button id="set-point" @click="createPoint()">设为途径点</button>
    </baidu-map>
    <div class="overlay" />
  </div>
</template>

<script>
import DistanceTool from "bmaplib.distancetool";
import { io } from "socket.io-client";
import markIcon from "../assets/images/marker-nodisc.png";
import markIconPurple from "../assets/images/marker-nodisc-purple.png";
import markIconRed from "../assets/images/marker-nodisc-red.png";
import markIconGreen from "../assets/images/marker-nodisc-green.png";
import markIconYellow from "../assets/images/marker-nodisc-yellow.png";
import markIconOrange from "../assets/images/marker-nodisc-orange.png";

export default {
  name: "Huizhou",
  unmount() {
    distanceTool && distanceTool.close();
  },
  data() {
    return {
      messageList: [],
      socket: io({
        reconnection: true,
        forceNew: true,
      }),
      center: { lng: 114.422152, lat: 23.117972 },
      icon: {
        0: markIcon,
        1: markIconPurple,
        2: markIconRed,
        3: markIconGreen,
        4: markIconYellow,
        5: markIconOrange,
      },
      iconNum: 0,
      count: 0,
      zoom: 16,
    };
  },
  mounted() {
    let _this = this;
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
    const points = [
      { lng: 114.422152, lat: 23.117972 }, //hz
      { lng: 113.758184, lat: 23.027314 }, // dg
      { lng: 114.70677, lat: 23.750654 }, // hy
      { lng: 113.062516, lat: 23.688306 }, // qy
      { lng: 113.603828, lat: 24.816859 }, // sg
      { lng: 113.408204, lat: 24.213542 }, // yd
    ];
    _this.socket.on("message", function (rank) {
      console.log(rank);

      if (points[rank - 2]) {
        _this.iconNum = rank - 2;
        _this.center = points[rank - 2];
      } else {
        _this.iconNum = getRandomInt(5);
        _this.center = points[getRandomInt(5)];
      }
    });
  },
  methods: {
    setDistanceToolInstance({ map }) {
      let _this = this;
      _this.distanceTool = new DistanceTool(map, { lineStroke: 2 });
      window.map = map;
    },
    handleOverflow() {
      alert("超出规划区域");
      this.center = { lng: 116.128554, lat: 24.294562 };
    },
    getTextLabel(text) {
      var offsetSize = new BMap.Size(0, 0);
      var labelStyle = {
        color: "#fff",
        backgroundColor: "#1DA1F2",
        border: "0",
        margin: "36px 10px 0",
        boxShadow: "0 0 5px #1DA1F2",
        borderRadius: "4px",
        padding: "0 6px",
      };
      //不同数字长度设置不同的样式。
      switch ((text + "").length) {
        case 1:
          labelStyle.fontSize = "14px";
          offsetSize = new BMap.Size(4, 2);
          break;
        case 2:
          labelStyle.fontSize = "12px";
          offsetSize = new BMap.Size(2, 4);
          break;
        case 3:
          labelStyle.fontSize = "10px";
          offsetSize = new BMap.Size(-2, 4);
          break;
        default:
          break;
      }
      var label = new BMap.Label(text, {
        offset: offsetSize,
      });
      label.setStyle(labelStyle);
      return label;
    },
    createPoint() {
      let _this = this;
      if (_this.count >= 1) {
        alert("最多设置一个途径点");
        return null;
      }
      let point = map.getCenter();
      _this.socket.emit("create_point", { point, iconNum: _this.iconNum });
      var myIcon = new BMap.Icon(
        _this.icon[_this.iconNum],
        new BMap.Size(56, 76)
      );
      let marker = new BMap.Marker(new BMap.Point(point.lng, point.lat), {
        icon: myIcon,
      });
      _this.count++;
      marker.setLabel(_this.getTextLabel(`途径点`));

      marker.addEventListener("click", function (e) {
        if (_this.messageList.find((item) => item.position == point))
          return null;
        let content = window.prompt("为当前标记点添加文本标注：");
        if (content) {
          _this.messageList.push({
            position: point,
            content: content,
          });
        }
      });
      map.addOverlay(marker);
    },
  },
};
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 100%;
  position: fixed;
}

#center-selector {
  width: 64px;
  height: 76px;
  background: url("../assets/images/marker.png");
  background-size: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -32px;
  margin-top: -38px;
  pointer-events: none;
}

#set-point {
  width: 100px;
  height: 35px;
  background: #1da1f2;
  color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0 8px #1da1f2;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: 45px;
  cursor: pointer;
  font-weight: bold;
}

.overlay {
  width: 100%;
  height: 50px;
  background: #fff;
  position: fixed;
}

.overlay:first-child {
  top: 0;
}

.overlay:last-child {
  bottom: 0;
}
</style>